export default __webpack_public_path__ + "static/media/arrow-left.32438ec2.svg";